// src/components/RemediationScorecardFeatureGuard.js
import { Navigate } from "react-router-dom";
import { useRemediationScorecard, useFeatureFlagsLoaded } from "../contexts/FeatureFlagsContext";
import { useRBAC } from "../hooks/useRBAC";
import { canAccessScorecard } from "./remediationScorecardNav";

// The scorecard is switched on per organization. The nav entry is hidden too; this covers direct
// URL access. Renders nothing until the flags have loaded so an opt-in flag is not mistaken for
// "off" on the first render. Also requires organization access (assignment-scoped users qualify,
// as they do on the API); the API filters what each user can read.
const RemediationScorecardFeatureGuard = ({ children }) => {
  const enabled = useRemediationScorecard();
  const loaded = useFeatureFlagsLoaded();
  const rbac = useRBAC();
  if (!loaded) return null;
  if (!enabled || !canAccessScorecard(rbac)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default RemediationScorecardFeatureGuard;
